import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Footer from "../../../components/footer/Footer";
import Scrollbar from "../../../components/scrollbar/scrollbar";

import "./NetworkingSolutions.css";
import "./PageTheme.css";
import serviceImage from "../../../images/perspectives.jpg";

type Block = { title?: string; text?: string; lines?: string[]; raw: string };

const config = {
  "title": "Networking Solutions",
  "category": "Software, Platforms & Infrastructure",
  "visual": "network",
  "folder": "NetworkingSolutions",
  "sections": [
    [
      "Networking Solutions",
      "Enabling Reliable Connectivity Across Intelligent Systems\nReliable connectivity is essential for modern electronic products. From embedded devices and industrial equipment to connected platforms and intelligent systems, networking enables secure communication, coordinated operation, and efficient data exchange across increasingly complex environments. As products become more connected, robust networking solutions play a critical role in ensuring performance, scalability, and long-term reliability.\n\nDigicomm Semiconductor provides specialized Networking Solutions that support the development and integration of communication frameworks across embedded, industrial, and connected systems. Our engineering teams work closely with customers to design, integrate, optimize, and validate networking solutions that enable dependable connectivity through disciplined engineering execution and collaborative product development.\n\nPrimary CTA\n\nDiscuss Your Networking Requirements"
    ],
    [
      "Networking Solutions",
      "Networking Solutions\nNetworking solutions enable electronic systems to communicate, exchange data, and operate as connected environments. They provide the communication framework that links embedded devices, processors, peripherals, gateways, and cloud-connected platforms, supporting reliable information exchange across industrial, automotive, consumer, and IoT applications. Well-engineered networking solutions improve interoperability, system performance, scalability, and operational reliability.\n\nDigicomm Semiconductor delivers comprehensive Networking Solutions that support the design, integration, optimization, and validation of communication frameworks for embedded and connected systems. Our engineering teams work collaboratively with customers to develop reliable networking architectures that enable secure connectivity, efficient data exchange, and seamless system integration throughout the product lifecycle.\n\nOur Networking Solutions Capabilities\nNetwork Architecture & Design\nCommunication Protocol Integration\nWired & Wireless Connectivity\nNetwork Stack Development & Integration\nSecure Communication Frameworks\nSystem Integration & Interoperability\nNetwork Performance Optimization\nConnectivity Validation & Testing"
    ],
    [
      "Why Networking Solutions Matter",
      "Why Networking Solutions Matter\nModern electronic products rarely operate in isolation. They interact with sensors, devices, gateways, cloud platforms, and other intelligent systems to exchange information, coordinate operations, and deliver connected experiences. Reliable networking solutions provide the communication framework that enables these interactions while ensuring data integrity, system performance, and operational continuity.\n\nAs connectivity becomes central to product functionality, networking engineering plays a critical role in enabling interoperability, supporting real-time communication, strengthening security, and preparing products to scale with evolving application requirements. Well-engineered networking solutions help organizations build connected products with greater confidence, reliability, and long-term adaptability.\n\nKey Outcomes\nReliable System Connectivity\n\nEnable dependable communication between embedded devices, hardware platforms, gateways, and connected systems through robust networking architectures.\n\nSeamless Interoperability\n\nSupport smooth interaction between diverse hardware, software, communication protocols, and intelligent devices across complex product ecosystems.\n\nSecure Data Communication\n\nStrengthen the integrity and reliability of data exchange through secure communication frameworks and resilient network design.\n\nScalable Connected Systems\n\nDevelop networking architectures that accommodate product expansion, additional devices, evolving technologies, and future connectivity requirements.\n\nOptimized Network Performance\n\nImprove communication efficiency, responsiveness, and overall system performance through optimized networking implementation.\n\nFuture-Ready Product Development\n\nBuild networking solutions that support evolving industry standards, emerging connectivity technologies, and long-term product evolution."
    ],
    [
      "Our Networking Solutions Capabilities",
      "Our Networking Solutions Capabilities\n\nReliable networking solutions require coordinated engineering across communication architectures, protocol implementation, connectivity, system integration, performance optimization, and validation. Digicomm supports the complete networking engineering lifecycle, helping customers develop secure, scalable, and high-performance communication frameworks for embedded and connected products.\n\nNetwork Architecture & Design\n\nDesign robust networking architectures that establish reliable communication frameworks for embedded, industrial, automotive, and connected electronic systems.\n\nCommunication Protocol Integration\n\nImplement and integrate industry-standard communication protocols to enable seamless interaction between devices, processors, peripherals, and networked systems.\n\nWired & Wireless Connectivity\n\nDevelop connectivity solutions that support reliable communication across wired and wireless interfaces, addressing diverse application and deployment requirements.\n\nNetwork Stack Development & Integration\n\nDevelop and integrate networking software stacks that enable efficient data communication, protocol management, and system interoperability.\n\nSecure Communication Frameworks\n\nImplement secure communication mechanisms that help protect data integrity, authentication, and reliable information exchange across connected systems.\n\nSystem Integration & Interoperability\n\nIntegrate networking capabilities with hardware platforms, embedded software, and application environments to ensure seamless system operation.\n\nNetwork Performance Optimization\n\nOptimize communication efficiency, latency, bandwidth utilization, and overall network performance to support application-specific requirements.\n\nConnectivity Validation & Testing\n\nValidate networking functionality, protocol compliance, interoperability, and communication reliability through structured engineering and testing methodologies."
    ],
    [
      "Key Benefits of Networking Solutions",
      "Key Benefits of Networking Solutions\n\nReliable networking solutions form the backbone of connected electronic products. By enabling secure communication, seamless interoperability, and efficient data exchange, they help engineering teams develop intelligent systems that perform consistently across diverse operating environments while remaining adaptable to future connectivity requirements.\n\nReliable Device Connectivity\n\nEnable consistent and dependable communication between embedded devices, hardware platforms, gateways, and connected systems across diverse applications.\n\nSeamless System Interoperability\n\nSupport efficient interaction between hardware, embedded software, communication protocols, and application environments, ensuring smooth system-wide operation.\n\nSecure Information Exchange\n\nStrengthen data integrity and communication reliability through secure networking frameworks that support trusted information exchange.\n\nScalable Connectivity Architecture\n\nDevelop networking solutions that accommodate product expansion, new devices, evolving technologies, and changing deployment requirements without compromising performance.\n\nOptimized Communication Performance\n\nImprove network responsiveness, bandwidth utilization, and communication efficiency to support reliable operation across embedded and connected systems.\n\nFuture-Ready Product Ecosystems\n\nBuild networking foundations that support evolving industry standards, emerging connectivity technologies, and long-term product growth."
    ],
    [
      "Technology Expertise",
      "Technology Expertise\nModern connected products rely on robust networking technologies to enable secure communication, real-time data exchange, and seamless interoperability. Delivering reliable networking solutions requires expertise across communication protocols, wired and wireless connectivity, protocol stacks, security frameworks, and network validation.\n\nDigicomm's Networking Solutions teams bring experience across a broad spectrum of networking technologies, helping customers develop scalable, high-performance communication frameworks that support connected products throughout their lifecycle.\n\nCommunication Protocols\nTCP/IP\nUDP\nMQTT\nHTTP / HTTPS\nCoAP\nDDS\nIndustrial & Embedded Protocols\nCAN / CAN FD\nModbus\nEtherCAT\nPROFINET\nOPC UA\nWired & Wireless Connectivity\nEthernet\nWi-Fi\nBluetooth / Bluetooth Low Energy (BLE)\nZigbee\nCellular (4G / 5G)\nNFC\nNetwork Security\nTLS / SSL\nSecure Socket Communication\nAuthentication & Authorization\nSecure Device Communication\nData Encryption\nDevelopment & Integration\nNetwork Stack Integration\nSocket Programming\nGateway Integration\nAPI Integration\nProtocol Interoperability\nValidation & Performance\nNetwork Performance Testing\nProtocol Compliance Validation\nConnectivity Testing\nInteroperability Testing\nNetwork Diagnostics"
    ],
    [
      "Why Digicomm",
      "Why Digicomm\nReliable networking solutions require more than implementing communication protocols. They demand a deep understanding of embedded systems, hardware platforms, software integration, and secure data communication to ensure consistent performance across complex product environments. Digicomm combines networking expertise with disciplined engineering practices to help customers build connected products that are reliable, scalable, and ready for evolving technology demands.\n\nWhat Sets Us Apart\nSpecialized Networking Engineering Expertise\n\nDedicated engineering teams experienced in designing, integrating, and optimizing networking solutions for embedded, industrial, automotive, and connected electronic systems.\n\nProtocol & System Integration\n\nA collaborative engineering approach that seamlessly integrates communication protocols, hardware platforms, embedded software, and application environments into reliable connected systems.\n\nDisciplined Engineering Execution\n\nStructured engineering methodologies focused on communication reliability, interoperability, performance optimization, and long-term maintainability.\n\nScalable Engineering Engagement\n\nFlexible engagement models that align with customer development programs, evolving connectivity requirements, and changing technology roadmaps.\n\nCommitment to Reliable Connectivity\n\nA continuous focus on delivering networking solutions that strengthen system performance, enable secure communication, and support dependable operation throughout the product lifecycle."
    ],
    [
      "Related Engineering Capabilities",
      "Related Engineering Capabilities\nEmbedded Software Systems\n\nDevelop intelligent embedded software that powers connected products, manages communication protocols, and enables reliable system functionality.\n\nLearn More →\n\nHardware Platform Engineering\n\nBuild robust hardware platforms that provide the foundation for reliable connectivity, system integration, and product development.\n\nLearn More →\n\nRelated Core Engineering Services\nSilicon Validation\n\nValidate communication interfaces, platform functionality, and system behavior to ensure reliable operation before product deployment.\n\nLearn More →\n\nSilicon Realization\n\nCoordinate engineering execution across hardware, software, networking, and implementation disciplines to enable successful product realization.\n\nLearn More →\n\nRelated Engineering Engagement Models\nEngineering Consulting\n\nWork with experienced networking specialists to address complex communication challenges and strengthen connected product development.\n\nLearn More →\n\nDedicated Engineering Teams\n\nExtend your engineering organization with networking engineers who integrate seamlessly into your product development programs.\n\nLearn More →"
    ],
    [
      "Engineer Connected Products with Confidence",
      "Engineer Connected Products with Confidence\n\nConnected products depend on networking solutions that are reliable, secure, and built to scale. Whether you're developing embedded communication frameworks, integrating wired or wireless connectivity, enabling secure data exchange, or optimizing network performance, Digicomm Semiconductor provides the engineering expertise to help you build connected systems through disciplined execution, collaborative engineering, and proven technical capability.\n\nPrimary CTA\n\nDiscuss Your Networking Requirements"
    ]
  ]
} as const;

const splitBlocks = (raw: string): string[] =>
  raw.split(/\n\s*\n/g).map((x) => x.trim()).filter(Boolean);

const asBlock = (raw: string): Block => {
  const lines = raw.split("\n").map((x) => x.trim()).filter(Boolean);
  if (lines.length >= 2 && lines[0].length <= 74) {
    const rest = lines.slice(1);
    const listLike = rest.length >= 3 && rest.every((x) => x.length < 78);
    if (listLike) return { title: lines[0], lines: rest, raw };
    return { title: lines[0], text: rest.join(" "), raw };
  }
  if (lines.length === 1) return { text: lines[0], raw };
  return { text: lines.join(" "), raw };
};

const getHero = (section: readonly string[], pageTitle: string) => {
  const merged = section.join("\n\n");
  const blocks = splitBlocks(merged);
  const filtered = blocks.filter((x) => x !== "Primary CTA");
  if (filtered[0] === pageTitle) filtered.shift();

  const first = filtered.shift() || pageTitle;
  const firstLines = first.split("\n").map((x) => x.trim()).filter(Boolean);
  const headline = firstLines[0] || pageTitle;
  const body: string[] = [];

  if (firstLines.length > 1) body.push(firstLines.slice(1).join(" "));
  filtered.forEach((b) => body.push(b));

  let cta = "";
  if (body.length && body[body.length - 1].length < 85) cta = body.pop() || "";
  return { headline, body, cta };
};

const Arrow = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M5 12h13M13 7l5 5-5 5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const EngineeringVisual: React.FC = () => (
  <div className="ses-visual service-engineering-image">
    <img src={serviceImage} alt="Connected semiconductor engineering network" />
  </div>
);

const ContentPanel: React.FC<{ raw: string; index: number }> = ({ raw, index }) => {
  const blocks = splitBlocks(raw).filter((x) => x !== "Primary CTA");
  return (
    <div className="ses-block-grid">
      {blocks.map((rawBlock, i) => {
        const block = asBlock(rawBlock);
        const long = rawBlock.length > 430;
        const labelOnly =
          !block.title &&
          !!block.text &&
          block.text.length < 80 &&
          (/[:：]$/.test(block.text) || i === 0);

        return (
          <article
            className={`ses-block ${long ? "ses-block--wide" : ""} ${labelOnly ? "ses-block--label" : ""}`}
            key={`${index}-${i}`}
          >
            {block.title && <h3>{block.title}</h3>}
            {block.text && (labelOnly ? <h3>{block.text}</h3> : <p>{block.text}</p>)}
            {block.lines && <ul>{block.lines.map((line) => <li key={line}>{line}</li>)}</ul>}
          </article>
        );
      })}
    </div>
  );
};

const RelatedPanel: React.FC<{ raw: string }> = ({ raw }) => {
  const blocks = splitBlocks(raw);
  const routeMap: Record<string, string> = {
    "Analog & Mixed Signal Design & Layout": "/services/analog-mixed-signal",
    "Analog & Mixed Signal": "/services/analog-mixed-signal",
    "Static Timing Analysis (STA)": "/services/static-timing-analysis",
    "FPGA Engineering": "/services/fpga-engineering",
    "Embedded Software Systems": "/services/embedded-software-systems",
    "Hardware Platform Engineering": "/services/hardware-platform-engineering",
    "Networking Solutions": "/services/networking-solutions",
    "Silicon Validation": "/services/silicon-validation",
    "EDA & Design Automation": "/services/eda-design-automation",
    "Product Engineering": "/services/product-engineering",
    "ASIC & SoC Design": "/services/asic-soc-design",
    "Physical Design": "/services/physical-design",
    "Verification Services": "/services/verification",
  };

  const cards: React.ReactNode[] = [];
  let group = "";

  blocks.forEach((b, i) => {
    if (/^Related .*:$/.test(b.trim())) {
      group = b.trim();
      return;
    }
    if (b === "Learn More →") return;

    const lines = b.split("\n").map((x) => x.trim()).filter(Boolean);
    const title = lines[0];
    const desc = lines.slice(1).join(" ");

    if (routeMap[title]) {
      cards.push(
        <Link className="ses-related-card" to={routeMap[title]} key={`${title}-${i}`}>
          <span>{group}</span>
          <h3>{title}</h3>
          {desc && <p>{desc}</p>}
          <em>Learn More <Arrow/></em>
        </Link>
      );
    } else {
      cards.push(
        <article className="ses-related-card" key={`${title}-${i}`}>
          <span>{group}</span>
          <h3>{title}</h3>
          {desc && <p>{desc}</p>}
        </article>
      );
    }
  });

  return <div className="ses-related-grid">{cards}</div>;
};

const Page: React.FC = () => {
  const sections = config.sections as readonly (readonly string[])[];
  const hero = getHero(sections[0] || [], config.title);

  const lastSection = sections[sections.length - 1] || [];
  const lastRaw = lastSection.join("\n\n");
  const lastBlocks = splitBlocks(lastRaw).filter((x) => x !== "Primary CTA");
  const ctaLabel =
    lastBlocks.length && lastBlocks[lastBlocks.length - 1].length < 90
      ? lastBlocks[lastBlocks.length - 1]
      : "";
  const ctaContent = ctaLabel ? lastBlocks.slice(0, -1) : lastBlocks;
  const hasRelated = sections.length === 9;

  useEffect(() => {
    document.title = `${config.title} | Digicomm Semiconductor`;
  }, []);

  return (
    <Fragment>
      <div className={`specialized-service-page inner-page networking-redesign`}>
        <div className="body_wrap o-clip">
          <Header />

          <main>
            <PageTitle pageTitle={config.title} pagesub={config.title} />

            <section className="ses-hero">
              <div className="ses-shell ses-two-col">
                <div className="ses-hero__copy">
                  <h1>{hero.headline}</h1>
                  {hero.body.map((p, i) => <p key={i}>{p}</p>)}
                  {hero.cta && (
                    <Link className="ses-btn" to="/contact">
                      {hero.cta}<Arrow/>
                    </Link>
                  )}
                </div>
                <EngineeringVisual />
              </div>
            </section>

            {sections.slice(1, hasRelated ? -2 : -1).map((section, idx) => {
              const raw = section.join("\n\n");
              const blocks = splitBlocks(raw);
              const lead = blocks[0] || "";
              const firstLine = lead.split("\n")[0] || "";

              return (
                <section className={`ses-section ses-section--${idx + 2} ${idx % 2 ? "ses-section--alt" : ""}`} key={idx}>
                  <div className="ses-shell">
                    <div className="ses-section-head">
                      <span>{String(idx + 2).padStart(2, "0")}</span>
                      <h2>{firstLine}</h2>
                    </div>
                    <ContentPanel raw={raw} index={idx}/>
                  </div>
                </section>
              );
            })}

            {hasRelated && (
              <section className="ses-section ses-related">
                <div className="ses-shell">
                  <RelatedPanel raw={sections[sections.length - 2].join("\n\n")}/>
                </div>
              </section>
            )}

            <section className="ses-cta">
              <div className="ses-shell ses-two-col">
                <div className="ses-cta__copy">
                  {ctaContent.map((b, i) => {
                    const lines = b.split("\n").map((x) => x.trim()).filter(Boolean);
                    return i === 0
                      ? <h2 key={i}>{lines.join(" ")}</h2>
                      : <p key={i}>{lines.join(" ")}</p>;
                  })}

                  {ctaLabel && (
                    <Link className="ses-btn" to="/contact">
                      {ctaLabel}<Arrow/>
                    </Link>
                  )}
                </div>
                <EngineeringVisual />
              </div>
            </section>
          </main>

          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default Page;

